import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

type LinkSchema = {
    label: string;
    onClick: () => void;
    dataAutomation?: string;
};

export const Link = ({ label, onClick, dataAutomation }: LinkSchema) => {
    return (
        <IconButton
            type="flat"
            onClick={onClick}
            iconName="arrow-slant-right"
            iconSize="16px"
            iconColor={colorsPalettes.blue[400]}
            placement="right"
            dataAutomation={dataAutomation}
        >
            {label}
        </IconButton>
    );
};
